import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/context";
import { Reveal } from "./Reveal";

export const WhyChooseUs = () => {
    const { t } = useLang();
    return (
        <section id="why-us" data-testid="why-choose-us-section" className="py-20 sm:py-28">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
                <Reveal>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#2A0505]">{t.why.heading}</h2>
                    <p className="font-display italic text-xl sm:text-2xl text-[#8D1717] mt-3">{t.why.priority}</p>
                    <p className="text-base sm:text-lg text-[#6B5B57] mt-3">{t.why.sub}</p>
                    <ul className="mt-8 space-y-4">
                        {t.why.points.map((point) => (
                            <li key={point} className="flex gap-3 items-start">
                                <CheckCircle2 className="w-6 h-6 text-[#8D1717] shrink-0 mt-0.5" />
                                <span className="text-base sm:text-lg text-[#2A0505] font-medium leading-relaxed">{point}</span>
                            </li>
                        ))}
                    </ul>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="rounded-3xl bg-white border border-[#EADFD8] shadow-xl shadow-[#2A0505]/5 p-10 sm:p-14 flex items-center justify-center">
                        <img src="/logo-full.png" alt="Brighten Services crest logo with wordmark" className="w-full max-w-sm" loading="lazy" />
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
